import OnboardingGuideWrapper from '@components/onboarding/OnboardingGuideWrapper'
import { tabletQuery } from '@globals/themes/themeConstants'
import Box from '@mui/material/Box'
import { SxProps } from '@mui/material/styles'
import { Nav } from '@nav/Nav'
import LicensingDialog from '@shared/licensing/LicensingDialog'
import SendAwardsModal from '@tenant/awards/sendAwardsModal/SendAwardsModal'
import SendNominationsModal from '@tenant/awards/sendNominationsModal/SendNominationsModal'
import MobileRecognitionDrawer from '@tenant/recognition/MobileRecognition'
import RecognitionModal from '@tenant/recognition/RecognitionModal/RecognitionModal'
import React from 'react'
import { useRouteUpdate } from './RouteUpdateContext'

const APPBAR_OFFSET = 24

const rootLayoutContainerStyle: SxProps = {
  flexGrow: 1,
  overflowX: 'auto',
  overflowY: 'auto',
  position: 'relative',
  p: 0,
  width: '100vw',
  [tabletQuery]: {
    // NOTE: Calculated offset for the appbar that is
    // rendered with the Nav component below it
    marginBottom: `${APPBAR_OFFSET}px`,
  },
}

const rootLayoutScrollStyle: SxProps = {
  flexGrow: 1,
  overflowX: 'hidden',
  overflowY: 'hidden',
  position: 'relative',
  minHeight: '100%',
  px: 6,
  pb: 6,
  [tabletQuery]: {
    px: 0,
    pb: 3,
    // NOTE: Calculated offset for the appbar that is
    // rendered with the Nav component below it
    marginBottom: `${APPBAR_OFFSET}px`,
  },
}

const RootLayout: React.FC<{
  isAuthenticated: boolean
  isTenantScope: boolean
  children: React.ReactElement | null
}> = ({ isAuthenticated, isTenantScope, children }) => {
  const { routeStyles, parentRef } = useRouteUpdate()

  return (
    <>
      <Box display="flex" alignItems="flex-start">
        {isAuthenticated && <Nav />}
        <Box sx={rootLayoutContainerStyle} component="main" ref={parentRef}>
          <Box
            sx={[
              rootLayoutScrollStyle,
              ...(Array.isArray(routeStyles) ? routeStyles : [routeStyles]),
            ]}>
            {children}
          </Box>
        </Box>
      </Box>
      {isAuthenticated && isTenantScope && <OnboardingGuideWrapper />}
      {isAuthenticated && (
        <>
          <RecognitionModal />
          <MobileRecognitionDrawer />
          <SendAwardsModal />
          <SendNominationsModal />
          <LicensingDialog />
        </>
      )}
    </>
  )
}

export default RootLayout
